export default __webpack_public_path__ + "static/media/family.inline.4f1ccbf3.svg";